import { render } from "./DeleteButton.vue?vue&type=template&id=0efa7bdd&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=js"
export * from "./DeleteButton.vue?vue&type=script&lang=js"

import "./DeleteButton.vue?vue&type=style&index=0&id=0efa7bdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0efa7bdd"]])

export default __exports__